import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  workOrderStatus: null,
  workOrderStatusList: [],
};

const route = "modules/settings/views/WorkOrderStatus/modals/deleteManageWorkOrderStatus/redux/slice";

export const manageDeleteManageWorkOrderStatus = createAsyncThunk("manage/deleteManageWorkOrderStatus/bulkDeleteWorkOrderStatus",async (payload, { rejectWithValue }) => {
    try {
        const response = await clientMutation(
          `mutation bulkDeleteWorkOrderStatus ($ids: [Int!]) {
            result: bulkDeleteWorkOrderStatus (ids: $ids)
          }`,
          payload,
          endpoints.GRAPHQL_GENERAL_V2
        );
    
        return { delete: response?.result }
    
      } catch (exc) {
        ExceptionManager(exc, route, "bulkDeleteWorkOrderStatus");
        return rejectWithValue(exc);
      }
  }
);


const manageDeleteManageWorkOrderStatusRedux = createSlice({
    name: "manage/deleteManageWorkOrderStatus",
    initialState: INIT_STATE,
    reducers: {
      reset(state, action) {
        return action.payload
          ? { ...state, ...action.payload }
          : { ...INIT_STATE };
      },
      openModalDeleteWorkOrderStatus(state, action) {
        state.open = true;
        state.workOrderStatus = action?.payload?.workOrderStatus;
        state.workOrderStatusList = action?.payload?.workOrderStatusList;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(resetALL, () => INIT_STATE);
  
      //manageDeleteManageWorkOrderStatus
      builder.addCase(manageDeleteManageWorkOrderStatus.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(manageDeleteManageWorkOrderStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
      builder.addCase(manageDeleteManageWorkOrderStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    },
  });
  
  // Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageWorkOrderStatusRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteWorkOrderStatus } = actions;

// Export the reducer, either as a default or named export
export default reducer;